<template>
  <div>
    <wc-section-title title='Work Orders'>
      <template v-slot:rightSide>
        <work-order-search></work-order-search>
      </template>
    </wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
import WOSearch from './WOSearch'
import { mapState } from 'vuex'

export default {
  name: 'work-order-base',
  computed: {
    menu () {
      return [
        {
          title: this.workorders.title + ' Dashboard',
          icon: this.workorders.icon,
          route: { name: 'WOsDashboard' }
        },
        {
          title: 'Ready for Office',
          icon: 'mdi-clipboard-edit-outline',
          route: { name: 'WOsReadyForOffice' }
        }
      ]
    },
    ...mapState({
        workorders: state => state.icons.modules.workorders
    })
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Work Orders Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  },
  components: {
    'work-order-search': WOSearch
  }
}
</script>
